module.exports = __webpack_public_path__ + "assets/img/jpjg.6d817fa9.png";